export interface UserFilter {
  searchFor?: string;
  page?: number;
  pagesize?: number;
  order?: string;
  direction?: number;
}

export const defaultUserFilterState: UserFilter = {
  searchFor: '',
  page: 1,
  pagesize: 12,
  order: 'name',
  direction: 1
};
